 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERED047DD1965A47CF9C74C8FA4E3436D9 from '@/components/covered047dd1965a47cf9c74c8fa4e3436d9'
 import C001 from '@/components/c001'
 import C002 from '@/components/c002'
 import TOC from '@/components/toc'
 import C003 from '@/components/c003'
 import C004 from '@/components/c004'
 import C005 from '@/components/c005'
 import C006 from '@/components/c006'
 import C007 from '@/components/c007'
 import C008 from '@/components/c008'
 import C009 from '@/components/c009'
 import C010 from '@/components/c010'
 import C011 from '@/components/c011'
 import C012 from '@/components/c012'
 import C013 from '@/components/c013'
 import C014 from '@/components/c014'
 import C015 from '@/components/c015'
 import C016 from '@/components/c016'
 import C017 from '@/components/c017'
 import C018 from '@/components/c018'
 import C019 from '@/components/c019'
 import C020 from '@/components/c020'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/c003",
 			"name" : "c003",
 			"component" : C003
 		},
 		{
 			"path" : "/c004",
 			"name" : "c004",
 			"component" : C004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js